<template>
  <v-app>
    <v-toolbar app class="app-toolbar">
      <v-btn :ripple="false" icon @click="$router.go(-1)">
        <v-icon class="icon-light">arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>Coronavirus</v-toolbar-title>
    </v-toolbar>
    <v-content pa-0>
      <v-container fluid>
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="corona"
          hide-actions
          class="elevation-1"
          v-if="corona != null">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.Country }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.TotalCases) }}</td>
            <td class="text-xs-right">{{ props.item.NewCases > 0 ? '+' + formatNumber(props.item.NewCases) : ''}}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.TotalDeaths) }}</td>
            <td class="text-xs-right">{{ props.item.NewDeaths > 0 ? '+' + formatNumber(props.item.NewDeaths) : '' }}
            </td>
            <td class="text-xs-right">{{ formatNumber(props.item.TotalRecovered) }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.ActiveCases) }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.Serious) }}</td>
          </template>
        </v-data-table>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
    import vas from '@/lib/VASClient';
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    {text: 'Country', value: 'Country'},
                    {text: 'Total Cases', value: 'TotalCases', align: 'right'},
                    {text: 'New Cases', value: 'NewCases', align: 'right'},
                    {text: 'Total Deaths', value: 'TotalDeaths', align: 'right'},
                    {text: 'New Deaths', value: 'NewDeaths', align: 'right'},
                    {text: 'Total Recovered', value: 'TotalRecovered', align: 'right'},
                    {text: 'Active Cases', value: 'ActiveCases', align: 'right'},
                    {text: 'Serious', value: 'Serious', align: 'right'}
                ],
                corona: null
            }
        },
        computed: {
            ...mapState(
                ['auth']
            ),
        },
        methods: {
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        },
        mounted() {
            var self = this;

            Loading.show('');

            vas.corona().then(function (response) {
                self.corona = response.data.countries;
                console.log("======================")
                console.log(this.corona)
                console.log("======================")
                Loading.hide();
            });
        }
    }
</script>
<style>
  .text-center {
    text-align: center;
  }

  .number {
    font-size: 3em;
  }
</style>
